import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountService } from '../../_services/account.service';
import { ModalRegisterPendingComponent } from '../modal-register-pending/modal-register-pending.component';

@Component({
  selector: 'app-modal-recuperar',
  templateUrl: './modal-recuperar.component.html',
  styleUrls: ['./modal-recuperar.component.css']
})
export class ModalRecuperarComponent implements OnInit {
  form: FormGroup;
  submitted = false;  
  errorService = false;
  errorMsg = '';

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private accountService: AccountService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required,
        Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)])],
    });
  }
  
  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;
    this.errorService = false;

    // stop here if form is invalid
    if (this.form.invalid) {
        return;
    }

    this.accountService.forgot(this.f.email.value).subscribe(data => {
      if(data instanceof HttpResponse) {
        var response = data.body;
        //Levantar un model
        this.modalService.dismissAll('Cross click');
        const modalRef = this.modalService.open(ModalRegisterPendingComponent, { 
          centered: true,  
          backdrop:'static',      
        });modalRef.componentInstance.padre = 'login';  
        if(response.msg === "SEND_MAIL_SUCCESS") {
          modalRef.componentInstance.titulo = 'Solicitud recibida';
          modalRef.componentInstance.texto = 'Le enviaremos un enlace a su correo electrónico para restaurar su contraseña.';
          modalRef.componentInstance.check = 'ok';
        } else {
          modalRef.componentInstance.titulo = 'Operación fallida';
          modalRef.componentInstance.check = 'error';
        }        
      }
    });
            
  } 

}
